import MetaData from './components/MetaData';
import FileUpload from './components/FileUpload';
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Divider, CircularProgress} from '@mui/material';
import SuiButton from "../../components/SoftButton";
import { IoClose } from "react-icons/io5";
import "../../assets/styles/dialogStyleSheet.css";
import PropTypes from "prop-types";
const ReferenceArticleDialog = ({ open, onClose, isUploading, handleCreateArticle }) => {

    const [isFocused, setIsFocused] = useState(false);
    const dir = "left";
    const inputContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        border: `1px solid ${isFocused ? '#cdcecf' : '#dcdfe3'}`,
        borderRadius: '8px',
        padding: '5px 10px',
        marginBottom: '10px',
        transition: 'border-color 0.3s ease',
    };

    const inputStyle = {
        width: '100%',
        padding: '10px 0px',
        border: 'none',
        fontSize: '14px',
        boxSizing: 'border-box',
        outline: 'none',
        fontFamily: 'Arial, Roboto',
    };
    const [formData, setFormData] = useState({
        title: '',
        authors: '',
        publicationDate: '',
        file: null,
        doi: ''
    });
    const [errors, setErrors] = useState({});
    const [disableUploadButton, setDisableUploadButton] = useState(true);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleFileUpload = (uploadedFiles) => {

        if (!uploadedFiles.length) return;

        setDisableUploadButton(true);

        const docFile = uploadedFiles.find(f =>
            f.type === 'application/pdf' ||
            f.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
            f.type === 'application/msword'
        );

        if (docFile) {
            setErrors(prev => ({ ...prev, file: '' }));
            setFormData(prev => ({
                ...prev,
                file: docFile,
                title: prev.title || docFile.name.replace(/\.[^/.]+$/, "")
            }));
            setDisableUploadButton(false);
        }


        if (!docFile ) {
            setErrors(prev => ({
                ...prev,
                file: 'Only PDF files are allowed',
            }));
            setDisableUploadButton(true);
        }
    };

    // VALIDATE FORM
    const validateForm = () => {
        let newErrors = {};
        if (!formData.title) newErrors.title = 'Title is required';
        if (!formData.file && !formData.files) newErrors.file = 'File upload is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleReferenceArticle = () => {
        if (validateForm() && !isUploading) 
        {
            const data = new FormData();
            data.append('title', formData.title);
            data.append('authors', formData.authors);
            data.append('doi', formData.doi);
            data.append('publication_date', formData.publicationDate);
            if(formData.file){
                data.append('file', formData.file);
            }
            handleCreateArticle(data);
        }
    };


    return (
        <Dialog open={open} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth PaperProps={{ style: { borderRadius: 15 } }}>
            <DialogTitle
                id="form-dialog-title"
                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f5f5f5', padding: '16px', fontSize: dir === "rtl" ? '1.3rem' : '1.5rem', }}
            >
                Upload Document
                <IoClose
                    aria-label="close"
                    onClick={onClose}
                    style={{ position: 'absolute', [dir === 'rtl' ? 'left' : 'right']: 8, top: 8, cursor: 'pointer' }}
                />
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ padding: "0px 24px" }}>
                <>
                    <FileUpload
                        setFormData={setFormData}
                        setErrors={setErrors}
                        handleFileUpload={handleFileUpload}
                        formData={formData}
                        errors={errors}
                        setDisableUploadButton={setDisableUploadButton}
                    />
                    <MetaData
                        inputContainerStyle={inputContainerStyle}
                        inputStyle={inputStyle}
                        formData={formData}
                        handleInputChange={handleInputChange}
                        setIsFocused={setIsFocused}
                        errors={errors}
                        requiredTitle={true}
                    />
                </>
            </DialogContent>
            <Divider />
            <DialogActions>
                    <>
                        <SuiButton variant="gradient" color="secondary" size="medium" onClick={onClose}  sx={{ml: 1, mr:  (dir === 'rtl' ? 1 : 0)}}>
                            Cancel
                        </SuiButton>
                        <SuiButton variant="gradient" color="primary" size="medium" onClick={handleReferenceArticle}
                                   disabled={disableUploadButton}
                                 
                                   >
                            {isUploading ? "Uploading..." : "Upload"}
                            {isUploading && <CircularProgress size={20} style={{ marginLeft: 10, color: "white" }} />}
                        </SuiButton>
                    </>
            </DialogActions>
        </Dialog>

    );
}

ReferenceArticleDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    handleCreateArticle: PropTypes.func,
    isUploading: PropTypes.bool
};

export default ReferenceArticleDialog;